<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.create_period' | translate }}
    v-card-content
      v-text-field(
        :label="$t('base.name')"
        v-model="form.name")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate")
        | {{ 'base.create' | translate }}
</template>

<script>
import api from '@/api'

export default {
  name: 'CreateLoadingModal',

  data: () => ({
    form: {
      name: '',
      ordering: 1
    },
    loading: false
  }),

  methods: {
    async onCreate () {
      const payload = {
        farm: this.$route.params.farm_id,
        ...this.form
      }
      this.loading = true
      const { errors } = await api.loadings.create(payload)
      if (!errors) {
        this.$emit('update')
        this.$emit('close')
      } else {
        this.$toasted.show(this.$t('Введіть назву періоду'))
      }
      this.loading = false
    }
  }
}
</script>
